import React, { useState } from 'react';
import { XMarkIcon, DocumentTextIcon, ShieldCheckIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';

interface Certificate {
  id: string;
  title: string;
  description: string;
  standard: string;
  validUntil: string;
  certNumber: string;
  image: string;
  fullImage: string;
  category: 'water' | 'gas' | 'industrial' | 'management';
}

const certificates: Certificate[] = [
  // Водоснабжение
  {
    id: 'cert-water-kz',
    title: 'Сертификат на трубы для водоснабжения (КАЗ)',
    description: 'Сертификат соответствия на полиэтиленовые трубы для систем водоснабжения (на казахском языке)',
    standard: 'СТ КЗ',
    validUntil: '2028',
    certNumber: 'KZ-WP-001',
    image: '/images/certificates/С-т водпр-д Каз.pdf',
    fullImage: '/images/certificates/С-т водпр-д Каз.pdf',
    category: 'water'
  },
  {
    id: 'cert-water-ru',
    title: 'Сертификат на трубы для водоснабжения (РУС)',
    description: 'Сертификат соответствия на полиэтиленовые трубы для систем водоснабжения (на русском языке)',
    standard: 'ГОСТ Р',
    validUntil: '2028',
    certNumber: 'RU-WP-001',
    image: '/images/certificates/С-т водпр-д Рус.pdf',
    fullImage: '/images/certificates/С-т водпр-д Рус.pdf',
    category: 'water'
  },
  {
    id: 'cert-water-coex-ru',
    title: 'Сертификат на соэкструзионные трубы (РУС)',
    description: 'Сертификат на соэкструзионные полиэтиленовые трубы для водоснабжения',
    standard: 'ГОСТ Р',
    validUntil: '2028',
    certNumber: 'RU-WPC-001',
    image: '/images/certificates/С-т водпр-д соэкстр. Рус.pdf',
    fullImage: '/images/certificates/С-т водпр-д соэкстр. Рус.pdf',
    category: 'water'
  },
  {
    id: 'cert-water-coex-kz',
    title: 'Сертификат на соэкструзионные трубы (КАЗ)',
    description: 'Сертификат на соэкструзионные полиэтиленовые трубы для водоснабжения (казахская версия)',
    standard: 'СТ КЗ',
    validUntil: '2028',
    certNumber: 'KZ-WPC-001',
    image: '/images/certificates/С-т водпр-д соэкструз.Каз.pdf',
    fullImage: '/images/certificates/С-т водпр-д соэкструз.Каз.pdf',
    category: 'water'
  },
  // Газоснабжение
  {
    id: 'cert-gas-kz',
    title: 'Сертификат на трубы для газоснабжения (КАЗ)',
    description: 'Сертификат соответствия на полиэтиленовые трубы для систем газоснабжения (казахская версия)',
    standard: 'СТ КЗ',
    validUntil: '2028',
    certNumber: 'KZ-GP-001',
    image: '/images/certificates/С-т газпр-д Каз.pdf',
    fullImage: '/images/certificates/С-т газпр-д Каз.pdf',
    category: 'gas'
  },
  {
    id: 'cert-gas-ru',
    title: 'Сертификат на трубы для газоснабжения (РУС)',
    description: 'Сертификат соответствия на полиэтиленовые трубы для систем газоснабжения (русская версия)',
    standard: 'ГОСТ Р',
    validUntil: '2028',
    certNumber: 'RU-GP-001',
    image: '/images/certificates/Ст-т газпр-д Рус.pdf',
    fullImage: '/images/certificates/Ст-т газпр-д Рус.pdf',
    category: 'gas'
  },
  {
    id: 'cert-gas-coex-kz',
    title: 'Сертификат на соэкструзионные газовые трубы (КАЗ)',
    description: 'Сертификат на соэкструзионные полиэтиленовые трубы для газоснабжения (казахская версия)',
    standard: 'СТ КЗ',
    validUntil: '2028',
    certNumber: 'KZ-GPC-001',
    image: '/images/certificates/С-т газпр-д соэкстр Каз.pdf',
    fullImage: '/images/certificates/С-т газпр-д соэкстр Каз.pdf',
    category: 'gas'
  },
  {
    id: 'cert-gas-coex-ru',
    title: 'Сертификат на соэкструзионные газовые трубы (РУС)',
    description: 'Сертификат на соэкструзионные полиэтиленовые трубы для газоснабжения (русская версия)',
    standard: 'ГОСТ Р',
    validUntil: '2028',
    certNumber: 'RU-GPC-001',
    image: '/images/certificates/С-т газпр-д соэкстр Рус.pdf',
    fullImage: '/images/certificates/С-т газпр-д соэкстр Рус.pdf',
    category: 'gas'
  },
  // Системы менеджмента
  {
    id: 'cert-quality',
    title: 'Система менеджмента качества',
    description: 'Сертификат соответствия системы менеджмента качества требованиям стандарта ISO 9001:2015 для производства полиэтиленовых труб',
    standard: 'ISO 9001:2015',
    validUntil: '2028',
    certNumber: 'QMS-002',
    image: '/images/certificates/certificate-2.jpg.pdf',
    fullImage: '/images/certificates/certificate-2.jpg.pdf',
    category: 'management'
  },
  {
    id: 'cert-environmental',
    title: 'Система экологического менеджмента',
    description: 'Сертификат соответствия системы экологического менеджмента требованиям стандарта ISO 14001:2015 для производства полиэтиленовых труб',
    standard: 'ISO 14001:2015',
    validUntil: '2028',
    certNumber: 'EMC-001',
    image: '/images/certificates/certificate-1.jpg.pdf',
    fullImage: '/images/certificates/certificate-1.jpg.pdf',
    category: 'management'
  },
  {
    id: 'cert-safety',
    title: 'Система управления охраной труда',
    description: 'Сертификат соответствия системы менеджмента профессиональной безопасности и здоровья требованиям стандарта ISO 45001:2018',
    standard: 'ISO 45001:2018',
    validUntil: '2028',
    certNumber: 'OHSMS-003',
    image: '/images/certificates/certificate-3.jpg.pdf',
    fullImage: '/images/certificates/certificate-3.jpg.pdf',
    category: 'management'
  },
  // Индустриальные
  {
    id: 'cert-industrial',
    title: 'Индустриальный сертификат',
    description: 'Индустриальный сертификат соответствия продукции требованиям промышленной безопасности',
    standard: 'Промышленная безопасность',
    validUntil: '2028',
    certNumber: 'IND-001',
    image: '/images/certificates/Индустриальный сертификат.pdf',
    fullImage: '/images/certificates/Индустриальный сертификат.pdf',
    category: 'industrial'
  },
  {
    id: 'cert-st-kz-2024',
    title: 'Сертификат СТ КЗ 2024',
    description: 'Сертификат соответствия стандартам Республики Казахстан на 2024 год',
    standard: 'СТ КЗ',
    validUntil: '2028',
    certNumber: 'ST-KZ-2024',
    image: '/images/certificates/Сертификат cт кз 2024.pdf',
    fullImage: '/images/certificates/Сертификат cт кз 2024.pdf',
    category: 'industrial'
  }
];

const categoryInfo = {
  water: {
    icon: ShieldCheckIcon,
    title: 'Водоснабжение',
    color: 'text-blue-600',
    bgColor: 'bg-blue-100'
  },
  gas: {
    icon: BuildingOfficeIcon,
    title: 'Газоснабжение',
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-100'
  },
  management: {
    icon: ShieldCheckIcon,
    title: 'Системы менеджмента',
    color: 'text-green-600',
    bgColor: 'bg-green-100'
  },
  industrial: {
    icon: DocumentTextIcon,
    title: 'Индустриальные',
    color: 'text-gray-600',
    bgColor: 'bg-gray-100'
  }
};

const CertificatesPage = () => {
  const [selectedCertificate, setSelectedCertificate] = useState<Certificate | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const filteredCertificates = selectedCategory === 'all' 
    ? certificates 
    : certificates.filter(cert => cert.category === selectedCategory);

  const openModal = (certificate: Certificate) => {
    setSelectedCertificate(certificate);
  };

  const closeModal = () => {
    setSelectedCertificate(null);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-secondary-900">
      {/* Header */}
      <div className="bg-white dark:bg-secondary-800 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
              🏆 Сертификаты и лицензии
            </div>
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-6">
              Сертификаты соответствия <span className="text-primary-600">ТОО «KazPolimerPlast»</span>
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 dark:text-secondary-300 max-w-4xl mx-auto">
              Наша компания имеет все необходимые сертификаты и лицензии, подтверждающие соответствие 
              международным и национальным стандартам качества для производства полиэтиленовых труб
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Статистика */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          <div className="text-center bg-white dark:bg-secondary-800 rounded-lg p-6 shadow-sm">
            <div className="text-3xl font-bold text-primary-600">13</div>
            <div className="text-sm text-gray-600 dark:text-secondary-300">Сертификатов соответствия</div>
          </div>
          <div className="text-center bg-white dark:bg-secondary-800 rounded-lg p-6 shadow-sm">
            <div className="text-3xl font-bold text-primary-600">4</div>
            <div className="text-sm text-gray-600 dark:text-secondary-300">Категории</div>
          </div>
          <div className="text-center bg-white dark:bg-secondary-800 rounded-lg p-6 shadow-sm">
            <div className="text-3xl font-bold text-primary-600">2028</div>
            <div className="text-sm text-gray-600 dark:text-secondary-300">Срок действия</div>
          </div>
          <div className="text-center bg-white dark:bg-secondary-800 rounded-lg p-6 shadow-sm">
            <div className="text-3xl font-bold text-primary-600">100%</div>
            <div className="text-sm text-gray-600 dark:text-secondary-300">Соответствие</div>
          </div>
        </div>

        {/* Фильтры */}
        <div className="flex flex-wrap gap-4 mb-8">
          <button
            onClick={() => setSelectedCategory('all')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              selectedCategory === 'all'
                ? 'bg-primary-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            Все сертификаты
          </button>
          {Object.entries(categoryInfo).map(([key, info]) => (
            <button
              key={key}
              onClick={() => setSelectedCategory(key)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                selectedCategory === key
                  ? `${info.bgColor} ${info.color}`
                  : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              {info.title}
            </button>
          ))}
        </div>

        {/* Сертификаты */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredCertificates.map((certificate) => {
            const categoryData = categoryInfo[certificate.category];
            const IconComponent = categoryData.icon;
            
            return (
              <div
                key={certificate.id}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
                onClick={() => openModal(certificate)}
              >
                <div className="relative">
                  <div className="w-full h-64 bg-gray-100 overflow-hidden">
                    <object 
                      data={certificate.image}
                      type="application/pdf"
                      className="w-full h-full"
                      style={{ transform: 'scale(0.8)', transformOrigin: 'top left' }}
                    >
                      <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                        <div className="text-center">
                          <DocumentTextIcon className="w-16 h-16 text-gray-400 mx-auto mb-2" />
                          <p className="text-gray-500 text-sm">PDF превью</p>
                        </div>
                      </div>
                    </object>
                  </div>
                  <div className={`absolute top-4 left-4 ${categoryData.bgColor} ${categoryData.color} px-3 py-1 rounded-full text-xs font-medium flex items-center`}>
                    <IconComponent className="w-3 h-3 mr-1" />
                    {categoryData.title}
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
                    {certificate.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                    {certificate.description}
                  </p>
                  
                  <div className="space-y-2 mb-4">
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Стандарт:</span>
                      <span className="font-medium">{certificate.standard}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Действителен до:</span>
                      <span className="font-medium">{certificate.validUntil}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Номер:</span>
                      <span className="font-medium">{certificate.certNumber}</span>
                    </div>
                  </div>
                  
                  <div className="mt-4">
                    <span className="inline-flex items-center text-primary-600 hover:text-primary-700 text-sm font-medium">
                      Посмотреть сертификат
                      <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Дополнительная информация */}
        <div className="mt-16 bg-white rounded-lg p-8 shadow-sm">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Наши сертификаты по категориям
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <ShieldCheckIcon className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Водоснабжение</h3>
              <p className="text-gray-600 text-sm">
                Сертификаты на полиэтиленовые трубы для систем водоснабжения, включая соэкструзионные
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <BuildingOfficeIcon className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Газоснабжение</h3>
              <p className="text-gray-600 text-sm">
                Сертификаты на полиэтиленовые трубы для газопроводов низкого и среднего давления
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <ShieldCheckIcon className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Системы менеджмента</h3>
              <p className="text-gray-600 text-sm">
                Международные стандарты ISO 9001, ISO 14001, ISO 45001
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <DocumentTextIcon className="w-8 h-8 text-gray-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Индустриальные</h3>
              <p className="text-gray-600 text-sm">
                Индустриальные сертификаты и стандарты Республики Казахстан
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedCertificate && (
        <div className="fixed inset-0 z-50 overflow-y-auto" onClick={closeModal}>
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity bg-black bg-opacity-75" />
            
            <div 
              className="inline-block w-full max-w-4xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                  {selectedCertificate.title}
                </h3>
                <button
                  onClick={closeModal}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <XMarkIcon className="w-6 h-6" />
                </button>
              </div>
              
              <div className="mb-4">
                <div className="w-full h-96 bg-gray-50 rounded overflow-hidden">
                  <object 
                    data={selectedCertificate.fullImage}
                    type="application/pdf"
                    className="w-full h-full"
                  >
                    <div className="w-full h-full bg-gray-50 rounded flex items-center justify-center">
                      <div className="text-center">
                        <DocumentTextIcon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                        <p className="text-gray-500 text-sm mb-2">PDF документ</p>
                        <a 
                          href={selectedCertificate.fullImage}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center text-primary-600 hover:text-primary-700 text-sm font-medium"
                        >
                          Открыть в новой вкладке
                          <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </object>
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <span className="text-sm text-gray-500">Стандарт:</span>
                  <p className="font-medium">{selectedCertificate.standard}</p>
                </div>
                <div>
                  <span className="text-sm text-gray-500">Действителен до:</span>
                  <p className="font-medium">{selectedCertificate.validUntil}</p>
                </div>
                <div>
                  <span className="text-sm text-gray-500">Номер сертификата:</span>
                  <p className="font-medium">{selectedCertificate.certNumber}</p>
                </div>
              </div>
              
              <p className="text-gray-600">
                {selectedCertificate.description}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CertificatesPage;